import { GraphQLClient } from 'graphql-request';

const createGraphqlClient = (url: string, method: 'GET' | 'POST') => {
  const client = new GraphQLClient(url, { method });

  return client;
};

export default createGraphqlClient;
